// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shell-CTv8Lm{background:var(--abr-bg-page,#f0f2f5);flex-direction:column;width:100%;height:100%;display:flex}.body-XChfFI{flex:1;min-height:0;display:flex;overflow:hidden}.main-Whix4E{flex:1;min-width:0;overflow:auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shell": `shell-CTv8Lm`,
	"body": `body-XChfFI`,
	"main": `main-Whix4E`
};
export default ___CSS_LOADER_EXPORT___;
